import { useContext } from 'react'
import EvidenceContext from './EvidenceContext'

const useEvidenceContext = () => {
    return useContext(EvidenceContext)
}

export default useEvidenceContext
